import TargetTask from "./TargetTask";

export default class Project {
	id ?: string;
	name : string;
	color : string;
	status ?: number;
	taskList : TargetTask[] | null;
	dateStart : string;
	dateEnd : string;

	constructor() {
		this.name = "";
		this.color = "#b8b8b8";
		this.taskList = null;
		this.dateStart = '';
		this.dateEnd = '';
	}
}